import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useCart } from '@/contexts/CartContext';

/**
 * Single-supplier cart safeguard.
 *
 * When the customer tries to add an item from a different supplier than the
 * one already in their cart, CartContext stashes the request and surfaces this
 * dialog instead of silently dropping/replacing items.
 */
export const ReplaceCartDialog = () => {
  const { pendingReplace, confirmReplace, cancelReplace } = useCart();
  const open = !!pendingReplace;

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && cancelReplace()}>
      <AlertDialogContent
        data-testid="replace-cart-dialog"
        className="bg-card border-border"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-2xl font-medium text-foreground">
            Replace cart?
          </AlertDialogTitle>
          <AlertDialogDescription className="font-body text-sm text-foreground/70 leading-relaxed pt-1">
            Your cart contains items from{' '}
            <span className="text-gold font-semibold">{pendingReplace?.currentSupplierName}</span>.
            You can only check out from one supplier at a time.
            <br /><br />
            Adding{' '}
            <span className="text-foreground font-semibold">{pendingReplace?.product?.name}</span>{' '}
            (from{' '}
            <span className="text-teal font-semibold">{pendingReplace?.incomingSupplierName}</span>)
            will clear your current cart.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel
            data-testid="replace-cart-cancel"
            className="rounded-full bg-teal-dark border border-transparent text-white hover:bg-teal font-body text-sm"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={confirmReplace}
            data-testid="replace-cart-confirm"
            className="rounded-full bg-[#C99A4E] border border-transparent text-charcoal hover:bg-gold-light font-body text-sm font-bold"
          >
            Replace Cart
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
